export enum ZPVUpdateResult {
    SUCCESS = 'SUCCESS',
    GESUCH_NOT_IN_STATE_FOR_ZPV_UPDATE = 'GESUCH_NOT_IN_STATE_FOR_ZPV_UPDATE',
    ERROR_NO_ZPV = 'ERROR_NO_ZPV',
    ERROR_BAD_GESUCHSTELLER = 'ERROR_BAD_GESUCHSTELLER',
    ERROR_ZPV_ALREADY_IN_GESUCH = 'ERROR_ZPV_ALREADY_IN_GESUCH'
}
